import { take } from 'rxjs/operators'
import { authSelectors } from 'src/app/core/auth/auth.selectors'
import { AppState } from 'src/app/core/core.state'
import { ConfigurationService } from 'src/app/shared/services/configuration.service'
import { environment } from 'src/environments/environment'

import { Component, OnInit } from '@angular/core'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { Store } from '@ngrx/store'

import { roleActions } from '../../role/role.actions'
import { userRoleActions } from '../../role/user-role/user-role.actions'
import { employeeContractActions } from '../employee-contract/employee-contract.actions'

import { UntilDestroy } from '@ngneat/until-destroy'
import { Router } from '@angular/router'
import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { AppRoutesNS } from 'src/app/app-routes.namespace'

@UntilDestroy()
@Component({
  selector: 'my-work-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class MyWorkIndexComponent implements OnInit {
  public activeTab: string = 'calendar'
  public employeeModuleConfig: any
  public supervisorModuleConfig: any

  public isMouseOverContract: boolean = false
  public isMouseOverSuprevisorBookings: boolean = false
  public isMouseOverCalendar: boolean = false
  public isMouseOverInvoice: boolean = false
  public appRoutesNS = AppRoutesNS
  constructor(
    private store: Store<AppState>,
    public configurationService: ConfigurationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.store.dispatch(
      BreadCrumbActions.addPageToHistory({
        pageName: 'myWorkModule.myWork',
        url: AppRoutesNS.Upcoming.UPCOMING_BOOKINGS,
        showBackArrow: false,
        titleName: 'myWorkModule.myWork'
      })
    )
    this.employeeModuleConfig = environment.moduleConfigs.employeeModule
    this.supervisorModuleConfig = environment.moduleConfigs.supervisorModule

    const index = this.router?.url.lastIndexOf('/')
    let subPath = this.router?.url.substring(index + 1)

    switch (subPath) {
      case 'calendar':
      case 'invoices':
        this.activeTab = subPath
        break
      case 'employee-contracts':
        this.activeTab = 'contracts'
        break

      case 'supervisor-bookings':
        this.activeTab = 'supervisorBookings'
        break
    }

    this.store.dispatch(roleActions.fetchMany({}))

    this.store
      .select(authSelectors.selectMember)
      .pipe(take(1))
      .subscribe((member) => {
        this.store.dispatch(
          userRoleActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: { userId: member.id }
            })
          })
        )
        this.store.dispatch(
          employeeContractActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: {
                personId: member.id
              },
              join: [
                { field: 'employeeBookings' },
                { field: 'employeeContractManagerLinks' },
                { field: 'debtorPerson' }
              ]
            })
          })
        )
      })
  }
}
